export const screenSzie = {
    smallPhone: 405,
    phone: 719,
    tablet:839,
    tabletxl:1279,
    desktop: 1439,
    desktopxl: 1920,
    
}

export const headerSzie ={
   xs:320,
   s:740,
   m:940,
   l:1099,
}